module.exports = __webpack_public_path__ + "static/media/banner_compendioCAP1_.61822288.jpg";